module.exports = __webpack_public_path__ + "img/1_021.372549b6.jpg";